// Compiled at 2026-09-18T12:45:23.821Z
// Auto-generated by Lowgile
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import type { OnAfterCodeLoad } from "@lg/shared";
import { BoInfoSymbol, HasChangedInternallySymbol } from "@lg/shared/for-apps";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared/for-apps";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => Currency.loadInternal(), entryList => {
        Currency.θentryList.set(entryList)
        Currency.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class Currency {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["label", "amountInChf"] as const,
        allPropertyNames: ["id", "label", "amountInChf"] as const,
        propertyNamesOfInterest: ["id", "label"] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<Currency.Id | null>;
    static readonly Id = String;
    static ids: Currency.Id[] = [] as any;
    static idsAndDisplayValues: Record<Currency.Id, string> = {} as any;
    static θentryList = signal<Currency.Entry[] | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<Currency.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'label';
    [immerable] = true;
    readonly θlabel = computed(() => {
        const id = this.θid()
        return id !== null ? Currency.getEntryMap()[id]?.label : undefined
    });
    readonly θamountInChf = computed(() => {
        const id = this.θid()
        return id !== null ? Currency.getEntryMap()[id]?.amountInChf : undefined
    });
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return Currency[BoInfoSymbol]
    }

    get __type(): 'Orders.Currency' {
        return 'Orders.Currency'
    }

    set __type(_) {
    }

    static get __type(): 'Orders.Currency' {
        return 'Orders.Currency'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id(): Currency.Id | null {
        return this.θid()
    }

    set id(id: Currency.Id | Currency | null) {
        if (id !== null && typeof id == 'object') { id = id.id }



        this.θid.set(id as Currency.Id | null)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get ids(): Currency.Id[] {
        return Currency.ids
    }

    get idsAndDisplayValues(): Record<Currency.Id, string> {
        return Currency.idsAndDisplayValues
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[Currency.$displayProperty])
    }

    get label() {
        return this.θlabel()
    }

    get amountInChf() {
        return this.θamountInChf()
    }

    get isCHF() {
        return this.id == 'CHF'
    }

    static get CHF() {
        return new this('CHF')
    }

    constructor(idOrObject: Currency.Id | Currency | null = null) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]): Currency.Entry[] {
        return This.Currency.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]): Currency.Entry[] {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: Currency.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof Currency.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = Currency.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<Currency.Entry[]> {
        async function getDynamicEntries() {
            try {
                return ExecutionService.executeMethodAndReturnData<any[]>('StaticEntity', 'Orders', 'Currency', undefined, 'getEntryList', [])
            } catch (err: any) {
                console.error('Error loading dynamic entries for Orders.Currency:', err)
                return []
            }

        }

        const dynamicEntryList = await getDynamicEntries()
        this.θchoicesCache.clear()
        return createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new Currency(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θtoIdAndOther(idOrObject: Currency.Id | Currency | null) {
        if (idOrObject && typeof idOrObject == 'object') {
            return { id: idOrObject.id }

        } else {
            return { id: idOrObject as Currency.Id | null, otherValue: '' }

        }
    }

    θupdate(idOrObject: Currency.Id | Currency) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid.set(id)

    }

    static θonEntryListUpdated() {
        this.ids = this.getEntryList().map(e => e.id)
        this.idsAndDisplayValues = Object.fromEntries(this.getEntryList().map(e => [e.id, e.$displayValue] as const)) as Record<Currency.Id, string>
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Orders.Currency yet:', err.message)
            //throw err
        })
    }

    setCHF() {
        this.id = 'CHF'

    }

    static θgetStaticEntryList() {
        return Object.freeze([

        ] as Currency.Entry[]) as Currency.Entry[]
    }
}
jsonClass('Orders.Currency')(Currency)

export const CurrencyθId = String;

export type CurrencyθId = string;

export namespace Currency {
    export type Id = 'CHF' | string

    export interface Entry {
        id: Currency.Id;
        label: string;
        amountInChf: number;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => Currency.load(true))
